import React, { useEffect, useState, useMemo } from "react";
import { Tooltip, Col, Card, Row, Spin, Switch } from "antd";
import { Select, Form, Input, message } from "antd";
import { CALL_API } from "../../../Common/api";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "../../../assets/images/edit-icon.svg";
import DeleteIcon from "../../../assets/images/delete-icon.svg";
import { ReactComponent as DeleteIcon1 } from "../../../assets/images/delete-icon.svg";
import { ReactComponent as EditIcon1 } from "../../../assets/images/Editicon.svg";
import { ReactComponent as ChangeRole } from "../../../assets/images/ChangeRole.svg";
import { ReactComponent as RedDelete } from "../../../assets/images/Red_Back_Delete.svg";
import Rotate from "../../../assets/images/Rotate.svg";
import styled from "styled-components";
import { CustomCheckbox } from "../../../Reusablecomponents/UIButtons";
import {
  ButtonFilled,
  Buttontransparent,
  ButtonOutlined,
} from "../../../Reusablecomponents/UIButtons/index";
import { LeftOutlined } from "@ant-design/icons";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import UIModal from "../../../Reusablecomponents/UIModal";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import dayjs from "dayjs";
import {
  setMyPermissionList,
  setSubscriptionList,
} from "../../../Redux/AuthSlice";
const { Option } = Select;

function permissionKey(secCode, actionCode) {
  return `${String(secCode || "")
    .trim()
    .toUpperCase()}|${String(actionCode || "")
    .trim()
    .toUpperCase()}`;
}

function buildPermissionTableRowsFromApi(groups = []) {
  const safeGroups = Array.isArray(groups) ? groups : [];
  const rows = safeGroups.flatMap((g) => {
    const groupName = g?.Group || g?.group || "";
    const sections = Array.isArray(g?.Sections) ? g.Sections : [];
    return sections.map((s) => {
      const actionsObj = s?.actions || {};
      const actions = Object.values(actionsObj)
        .filter(Boolean)
        .map((a) => ({
          code: a?.code,
          desc: a?.desc,
          canDo: false,
        }))
        .filter((a) => a.code);

      return {
        key: s?.secCode || `${groupName}-${s?.section}`,
        module: groupName,
        page: s?.section || "",
        secCode: s?.secCode || "",
        actions,
      };
    });
  });

  // Apply rowSpan for the "Module" column
  let i = 0;
  while (i < rows.length) {
    const mod = rows[i].module;
    let span = 1;
    while (i + span < rows.length && rows[i + span].module === mod) span += 1;
    rows[i].moduleRowSpan = span;
    for (let j = 1; j < span; j += 1) rows[i + j].moduleRowSpan = 0;
    i += span;
  }
  return rows;
}

function buildPermissionMapFromCatalog(groups = []) {
  const next = {};
  const safeGroups = Array.isArray(groups) ? groups : [];
  safeGroups.forEach((g) => {
    const sections = Array.isArray(g?.Sections) ? g.Sections : [];
    sections.forEach((s) => {
      const secCode = s?.secCode;
      const actionsObj = s?.actions || {};
      Object.values(actionsObj)
        .filter(Boolean)
        .forEach((a) => {
          if (!a?.code) return;
          next[permissionKey(secCode, a.code)] = false;
        });
    });
  });
  return next;
}

function buildPermissionMapFromCatalogAndSelected(
  catalogGroups = [],
  selected = [],
) {
  const next = buildPermissionMapFromCatalog(catalogGroups);
  const items = Array.isArray(selected) ? selected : [];
  items.forEach((item) => {
    const sec = item?.SECCODE ?? item?.secCode;
    const act = item?.ACTION ?? item?.action;
    if (!sec || !act) return;
    next[permissionKey(sec, act)] = true;
  });
  return next;
}

const WrapperBox = styled.div`
  .Create_btn {
    border: 1px solid rgb(231, 231, 237);
    outline: none;
    background-color: #ffffff;
    color: white;
    border-radius: 70%;
    padding: 17px 13px 17px 13px;
    font-size: 16px;
  }
  .Create_btn_edit {
    border-radius: 50%;
    padding: 9px;
    border: 1px solid rgb(231, 231, 237);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
  }
  .left_outlined_icon {
    color: rgb(44, 150, 61);
    transform: scale(0.8);
  }
  .consingment_container_two {
    display: flex;
    gap: 10px;
    margin-left: auto;
    justify-content: flex-end;
  }
  .consingment_container_formbresponsive {
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: flex-end;
    width: 100%;
  }
  .action-hover-container {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .rotate-icon {
    width: 24px;
  }

  /* Hide text by default */
  .action-text {
    opacity: 0;
    transform: translateX(-5px);
    transition: all 0.2s ease;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 500;
    color: #2c963d;
  }

  /* Show on hover */
  .action-hover-container:hover .action-text {
    opacity: 1;
    transform: translateX(0);
  }
`;
const Role = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [filterRole, setFilterRole] = useState([]);
  const [filterUser, setFilterUser] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [userRolesData, setUserRolesData] = useState([]);
  const [roleActionData, setRoleActionData] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [isEditRole, setIsEditRole] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRoleFormView, setIsRoleFormView] = useState(false);
  const [permissionMap, setPermissionMap] = useState({});
  const permissionTableData = useMemo(
    () => buildPermissionTableRowsFromApi(permissions),
    [permissions],
  );
  const allPermissionKeys = useMemo(
    () =>
      permissionTableData.flatMap((row) =>
        (row.actions || []).map((a) => permissionKey(row.secCode, a.code)),
      ),
    [permissionTableData],
  );
  const [formData, setFormData] = useState({
    rolename: "",
  });

  const resetPermissionSelections = () => {
    if (Array.isArray(permissions) && permissions.length) {
      setPermissionMap(buildPermissionMapFromCatalog(permissions));
      return;
    }
    const next = {};
    allPermissionKeys.forEach((k) => {
      next[k] = false;
    });
    setPermissionMap(next);
  };

  const openCreateRoleForm = async () => {
    setIsEditRole(false);
    setFormData({ rolename: "" });
    form.resetFields();
    const catalog = await fetchAllRoleAction(userInfo?.ROLEID);
    setPermissionMap(buildPermissionMapFromCatalog(catalog));
    setIsRoleFormView(true);
  };

  const openEditRoleForm = async (record) => {
    setIsEditRole(true);
    setFormData({
      roleid: record?.ROLEID,
      rolename: record?.ROLENAME,
      MCID: record?.MCID ?? userInfo?.MCID,
    });
    form.setFieldsValue({
      rolename: record?.ROLENAME || "",
    });
    const catalog = await fetchAllRoleAction(record?.ROLEID);
    const selected = await fetchActionsByRoleId(record?.ROLEID);
    setPermissionMap(
      buildPermissionMapFromCatalogAndSelected(catalog, selected),
    );
    setIsRoleFormView(true);
  };
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [currentAssignedPage, setCurrentroleAssignedPage] = useState(1);
  const [roleAssignedPageSize, setRoleAssignedPageSize] = useState(10);
  const [dataforroleassign, setDataforroleassign] = useState([]);
  const [roleAssignId, setRoleAssignId] = useState(null);
  const [assignedRoleLoading, setAssignedRoleLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteModalOpen1, setIsDeleteModalOpen1] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [isUsersView, setIsUsersView] = useState(false);
  const [roleUserList, setRoleUserList] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedUserRole, setSelectedUserRole] = useState(null);
  const [userRolesTotal, setUserRolesTotal] = useState(0);
  const roles = useSelector((state) => state?.authTracking?.roleList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const roleList = useSelector((state) => state?.authTracking?.roleList);
  // Filter roles based on search
  const filteredRoles = roles.filter((role) =>
    role?.ROLENAME.toLowerCase().includes(searchText.toLowerCase()),
  );
  const userList = useSelector((state) => state?.authTracking?.userList);
  const handleChange = (value) => {
    setSelectedUserRole(value);
    form.setFieldsValue({ rolename: value });
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const handlePageChange1 = (page, pageSize) => {
    setCurrentroleAssignedPage(page);
    setRoleAssignedPageSize(pageSize);
  };

  const handlePageSizeChange1 = (value) => {
    setRoleAssignedPageSize(value);
    setCurrentroleAssignedPage(1);
  };

  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const createAllowed = useMemo(
    () => hasPermission("ROLE", "C"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("ROLE", "U"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("ROLE", "D"),
    [reduxPermissions],
  );
  const deleteUserRoleAllowed = useMemo(
    () => hasPermission("ROLE", "DRFU"),
    [reduxPermissions],
  );
  const assignRoleAllowed = useMemo(
    () => hasPermission("ROLE", "ARTU"),
    [reduxPermissions],
  );
  const openDeleteModal = (record) => {
    setRecordToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setRecordToDelete(null);
  };

  const openDeleteModal1 = () => {
    setIsDeleteModalOpen1(true);
  };

  const closeDeleteModal1 = () => {
    setIsDeleteModalOpen1(false);
  };

  const handleCancel = () => {
    setIsRoleFormView(false);
    setFormData({
      rolename: "",
    });
    form.resetFields();
    form.setFieldsValue({
      rolename: "",
    });
    setIsEditRole(false);
    resetPermissionSelections();
  };

  const setPermKeys = (keys, checked) => {
    setPermissionMap((prev) => {
      const next = { ...prev };
      keys.forEach((k) => {
        next[k] = checked;
      });
      return next;
    });
  };

  const permissionColumns = useMemo(() => {
    const allSelected =
      allPermissionKeys.length > 0 &&
      allPermissionKeys.every((k) => permissionMap[k]);
    const someSelected = allPermissionKeys.some((k) => permissionMap[k]);

    return [
      {
        title: (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <CustomCheckbox
              checked={allSelected}
              indeterminate={someSelected && !allSelected}
              onChange={(e) => setPermKeys(allPermissionKeys, e.target.checked)}
            />
            Modules
          </span>
        ),
        dataIndex: "module",
        key: "module",
        width: "22%",
        render: (text, row) => {
          if (row.moduleRowSpan === 0) {
            return { children: null, props: { rowSpan: 0 } };
          }
          const keys = permissionTableData
            .filter((r) => r.module === row.module)
            .flatMap((r) =>
              (r.actions || []).map((a) => permissionKey(r.secCode, a.code)),
            );
          const all = keys.length > 0 && keys.every((k) => permissionMap[k]);
          const some = keys.some((k) => permissionMap[k]);
          return {
            children: (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <CustomCheckbox
                  checked={all}
                  indeterminate={some && !all}
                  onChange={(e) => setPermKeys(keys, e.target.checked)}
                />
                {text}
              </span>
            ),
            props: { rowSpan: row.moduleRowSpan },
          };
        },
      },
      {
        title: "Pages",
        dataIndex: "page",
        key: "page",
        width: "22%",
        render: (_, row) => {
          const keys = (row.actions || []).map((a) =>
            permissionKey(row.secCode, a.code),
          );
          const all = keys.length > 0 && keys.every((k) => permissionMap[k]);
          const some = keys.some((k) => permissionMap[k]);
          return (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <CustomCheckbox
                checked={all}
                indeterminate={some && !all}
                onChange={(e) => setPermKeys(keys, e.target.checked)}
              />
              {row.page}
            </span>
          );
        },
      },
      {
        title: "Actions",
        key: "actions",
        render: (_, row) => (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px 18px",
              alignItems: "center",
            }}
          >
            {(row.actions || []).map((action) => {
              const pk = permissionKey(row.secCode, action.code);
              return (
                <span
                  key={pk}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 9,
                    marginTop: 5,
                  }}
                >
                  <CustomCheckbox
                    checked={!!permissionMap[pk]}
                    onChange={(e) => setPermKeys([pk], e.target.checked)}
                  />
                  {action?.desc || action?.code}
                </span>
              );
            })}
          </div>
        ),
      },
    ];
  }, [permissionMap, allPermissionKeys, permissionTableData]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    if (checked) {
      setSelectedRows(userRolesData.map((row) => row.UID));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowCheck = (checked, UID) => {
    const updated = checked
      ? [...selectedRows, UID]
      : selectedRows.filter((id) => id !== UID);

    setSelectedRows(updated);
    setSelectAll(updated.length === userRolesData.length);
  };

  const RolesColumn = [
    {
      title: "Role Name",
      dataIndex: "ROLENAME",
      key: "ROLENAME",
    },
    {
      title: "Users",
      dataIndex: "UserCount",
      key: "UserCount",
    },
    {
      title: "Actions",
      width: 50,
      key: "actions",
      render: (_, record) => (
        <Tooltip title={!updateAllowed ? "No permission" : ""}>
          <img
            src={EditIcon}
            style={{
              color: "#E4A400",
              // width: "18px",
              // cursor: updateAllowed ? "pointer" : "not-allowed",
            }}
            onClick={(e) => {
              if (!updateAllowed) return;
              e.stopPropagation();
              openEditRoleForm(record);
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: "",
      width: 50,
      key: "actions",
      render: (_, record) => (
        <Tooltip title={!deleteAllowed ? "No permission" : ""}>
          <img
            src={DeleteIcon}
            style={{
              color: "red",
              cursor: deleteAllowed ? "pointer" : "not-allowed",
            }}
            onClick={(e) => {
              if (!deleteAllowed) return;
              e.stopPropagation();
              if (record?.UserCount > 0) {
                openDeleteModal1(); // Show "cannot delete" modal
              } else {
                openDeleteModal(record); // Show normal delete modal
              }
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: "",
      width: 100,
      key: "plainspace",
    },
  ];

  const UserRolesColumn = [
    {
      title: (
        <CustomCheckbox
          checked={selectAll}
          onChange={(e) => handleSelectAll(e.target.checked)}
          className="fuel-select-all"
        />
      ),
      dataIndex: "checkbox",
      key: "checkbox",
      width: 50,
      render: (_, record) => (
        <CustomCheckbox
          checked={selectedRows.includes(record.UID)}
          onChange={(e) => handleRowCheck(e.target.checked, record.UID)}
          onClick={(e) => e.stopPropagation()} // prevent row onClick from firing
        />
      ),
    },
    {
      title: "User ID",
      dataIndex: "USERID",
      key: "USERID",
    },
    {
      title: "Name",
      dataIndex: "FULLNM",
      key: "FULLNM",
    },
    {
      title: "Email",
      dataIndex: "EMAIL",
      key: "EMAIL",
    },
    {
      title: "Updated By",
      dataIndex: "ADDEDBY",
      key: "ADDEDBY",
      render: (addedBy, row) => {
        const users = Array.isArray(userList) ? userList : userList?.data || [];
        const addedByName =
          users?.find((item) => item?.UID === addedBy)?.FULLNM || "-";
        return (
          <div className="consingment_container_record">
            <p>{addedByName}</p>
            <i style={{ color: "#8492B1" }}>
              {dayjs(row?.ASSIGNED).format("Do MMM YYYY; hh:mm A")}
            </i>
          </div>
        );
      },
    },
    {
      title: "Action",
      width: 50,
      key: "actions",
      render: (_, record) => {
        return (
          <Tooltip title={!assignRoleAllowed ? "No permission" : ""}>
            <div
              className="action-hover-container"
              onClick={(e) => {
                if (!assignRoleAllowed) return;
                setRoleAssignId(record?.UID);
                e.stopPropagation();
                setFormData({
                  UID: record?.UID,
                });
                // Set the user's current role as selectedRole
                setSelectedRole(record?.ROLEID);
                form.setFieldsValue({
                  rolename: record?.ROLEID,
                });
                // If this UID is not in selectedRows, set it as the only selected row
                if (!selectedRows.includes(record?.UID)) {
                  setSelectedRows([record?.UID]);
                }
                setIsCRoleModalOpen(true);
              }}
              style={{
                cursor: assignRoleAllowed ? "pointer" : "not-allowed",
              }}
            >
              <img src={Rotate} className="rotate-icon" />
              <span className="action-text">Change Role</span>
            </div>
          </Tooltip>
        );
      },
    },
  ];

  const fetchAllRoleAction = async (roleId) => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "role/roleAction", {
        MCID: userInfo?.MCID,
        ROLEId: roleId ?? 0,
      });
      setPermissions(data);
      return data;
    } catch (error) {
      console.error("[fetchAllRoleAction] error:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const fetchActionsByRoleId = async (roleId) => {
    if (!roleId) return [];
    try {
      const response = await CALL_API(
        "GET",
        `role/getActionsByRoleId?mcId=${userInfo?.MCID}&RoleId=${roleId}`,
      );
      return response?.data || [];
    } catch (error) {
      console.error("[fetchActionsByRoleId] error:", error);
      return [];
    }
  };

  const fetchAllUserRoles = async (ROLEID, UID) => {
    if (!ROLEID) return;
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `roles/getAllRolesAssigned?limit=${roleAssignedPageSize}&page=${currentAssignedPage}&mcid=${userInfo?.MCID}&ROLEID=${ROLEID}&UID=${UID}`,
        {},
      );
      setUserRolesData(Array.isArray(data?.data) ? data.data : []);
      setUserRolesTotal(data?.totalRecords || 0);
    } catch (error) {
      console.error("[fetchAllUserRoles] error:", error);
      setUserRolesData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllUserRolesList = async (roleIdOverride) => {
    try {
      setLoading(true);
      let url = `common/getRoleWithUser?MCID=${userInfo?.MCID}`;
      const effectiveRoleId =
        roleIdOverride !== undefined ? roleIdOverride : selectedRole?.ROLEID;
      if (effectiveRoleId) {
        url += `&ROLEID=${effectiveRoleId}`;
      }
      const { data } = await CALL_API("GET", url, {});
      setRoleUserList(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("[fetchAllUserRoles] error:", error);
      setRoleUserList([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleRowClick = async (record) => {
    setSelectedRole(record);
    setIsUsersView(true);
    setCurrentroleAssignedPage(1);
    setRoleAssignedPageSize(10);
    await fetchAllUserRoles(record?.ROLEID);
  };

  const handleBackToRoles = () => {
    setIsUsersView(false);
    setSelectedRole(null);
    setSelectedUserRole(null);
    setUserRolesData([]);
  };

  const buildSelectedRoleActionsPayload = () => {
    return Object.entries(permissionMap || {})
      .filter(([, v]) => !!v)
      .map(([k]) => {
        const [secCode, action] = String(k).split("|");
        return {
          secCode: String(secCode || "").trim(),
          action: String(action || "").trim(),
        };
      })
      .filter((x) => x?.secCode && x?.action);
  };

  const saveRoleActions = async (roleId) => {
    const selectedRoles = buildSelectedRoleActionsPayload();
    await CALL_API(
      "POST",
      `role/addActionToRole?roleId=${roleId}`,
      selectedRoles,
    );
  };

  const fetchMyPermissions = async () => {
    try {
      const { data } = await CALL_API("GET", `role/getMyPermissions`);

      // Normalize response (flatten nested arrays if present)
      let items = data ?? [];
      if (
        Array.isArray(items) &&
        items.length === 1 &&
        Array.isArray(items[0])
      ) {
        items = items[0];
      }
      if (Array.isArray(items) && items.some(Array.isArray))
        items = items.flat(1);

      const perms = (items || []).reduce((acc, item) => {
        const code = (item?.SECCODE || "").toUpperCase();
        const action = (item?.ACTION || "").toUpperCase();
        if (!code) return acc;
        if (!acc[code]) acc[code] = new Set();
        acc[code].add(action);
        return acc;
      }, {});

      const permObj = Object.keys(perms).reduce((acc, k) => {
        acc[k] = Array.from(perms[k]);
        return acc;
      }, {});

      dispatch(setMyPermissionList(permObj));
    } catch (err) {
      console.error("Error loading permissions:", err);
      dispatch(setMyPermissionList({}));
    }
  };

  const fetchSubscriptionsMenu = async () => {
    if (userInfo?.MCID == null || userInfo?.MCID === "") return;
    try {
      const res = await CALL_API(
        "GET",
        `subscription/getById?McID=${userInfo.MCID}`,
      );
      const rows = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res)
          ? res
          : [];
      const subscriptionSecCodes = rows
        .map((sub) => sub.SECCODE?.trim()?.toUpperCase())
        .filter(Boolean);

      dispatch(setSubscriptionList(subscriptionSecCodes));
    } catch (error) {
      console.error("[fetchSubscriptions] error:", error);
    }
  };

  const handleCreateRole = async (values) => {
    const { permissions: _permissions, ...roleValues } = values || {};
    const payload = {
      UID: userInfo?.UID,
      ROLENAME: roleValues?.rolename,
      MCID: userInfo?.MCID,
      ACTION: "INSERT",
    };
    const editpayload = {
      UID: userInfo?.UID,
      ACTION: "UPDATE",
      ROLEID: formData?.roleid,
      ROLENAME: roleValues?.rolename,
      MCID: formData?.MCID,
    };
    try {
      setLoading(true);
      const {
        data,
        message: Message,
        ResponseCode,
      } = await CALL_API(
        "POST",
        `role/create_role`,
        isEditRole ? editpayload : payload,
      );

      if (ResponseCode === 200) {
        const createdRoleId =
          data?.insertedData?.TenantDBData?.[0]?.ROLEID ||
          data?.insertedData?.ROLEID;
        const roleIdToSave = isEditRole ? formData?.roleid : createdRoleId;

        try {
          if (roleIdToSave) {
            await saveRoleActions(roleIdToSave);
          }
        } catch (e) {
          console.error("[saveRoleActions] error -->", e);
          message.warning("Role saved, but permissions could not be saved");
        }

        fetchRolesData();
        fetchMyPermissions();
        fetchSubscriptionsMenu();
        handleCancel();
        setLoading(false);
        message.success(
          isEditRole
            ? "Role Updated Successfully"
            : "Role Created Successfully",
        );
      } else {
        setLoading(false);
        message.warning(Message);
      }
    } catch (error) {
      setLoading(false);
      console.error("[handleCreateRole] error -->", error);
    }
  };

  // const handleAction = async () => {
  //   try {
  //     setLoading(true);
  //     const { data } = await CALL_API(
  //       "POST",
  //       `role/addActionToRole?roleId=${selectedRole}`,
  //       selectedRoles,
  //     );
  //     message.success("Role Action Added Successfully");
  //     fetchSubscriptionData();
  //     fetchMyPermissions();
  //   } catch (error) {
  //     console.error("[handleAction] error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleDeleteRole = async () => {
    if (!recordToDelete) return;

    const payload = {
      UID: userInfo?.UID,
      ROLEID: recordToDelete?.ROLEID,
      // ROLENAME: recordToDelete?.ROLENAME,
      // MCID: recordToDelete?.MCID,
      // ACTION: "DELETE",
    };
    try {
      setLoading(true);
      const { data } = await CALL_API("Delete", `/role/Deleterole`, payload);

      fetchRolesData();
      if (data?.insertedData?.noOfUsers === 0) {
        message.success("Role deleted successfully");
      } else {
        message.error(
          data?.message ||
            "Role cannot be deleted because it is assigned to users",
        );
      }
      setLoading(false);
      setIsDeleteModalOpen(false);
      setIsDeleteModalOpen1(false);
    } catch (error) {
      setLoading(false);
      console.error("[handleCreateRole] error -->", error);
    }
  };

  const fetchRolesData = async (ROLEID) => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `roles/getAllRoles?limit=${pageSize}&page=${currentPage}&ROLEID=${ROLEID}`,
        {},
      );
      setRolesData(data?.data);
      setTotal(data?.totalRecords || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const changeRole = async () => {
    try {
      setLoading(true);

      const { data } = await CALL_API("POST", "role/assign_role", {
        RoleID: selectedUserRole,
        UserIds: selectedRows,
        AddedBy: userInfo?.UID,
      });
      fetchRolesData();
      getRolebyUser();
      setIsCRoleModalOpen(false);
      setSelectedRows([]); // optional reset
      setIsUsersView(false);
    } catch (error) {
      console.error("[changeRole] error:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchRoleActionData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `roles/getAllRolesActions?limit=10&page=1`,
        {},
      );
      setRoleActionData(data?.data);
      setLoading(false);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    }
  };

  const getRolebyUser = async () => {
    setAssignedRoleLoading(true);
    const { data } = await CALL_API(
      "GET",
      `role/getRolebyUserId?userId=${roleAssignId}`,
      {},
    );
    setDataforroleassign(data);
    setAssignedRoleLoading(false);
  };

  useEffect(() => {
    fetchRoleActionData();
    fetchAllUserRolesList();
    fetchSubscriptionsMenu();
  }, []);

  useEffect(() => {
    if (!selectedRole?.ROLEID) return;
    fetchAllUserRoles(selectedRole?.ROLEID, filterUser || "");
  }, [
    selectedRole?.ROLEID,
    currentAssignedPage,
    roleAssignedPageSize,
    filterUser,
  ]);

  useEffect(() => {
    if (selectedRole?.ROLEID) {
      fetchAllUserRolesList(selectedRole?.ROLEID);
    }
  }, [selectedRole]);

  useEffect(() => {
    fetchRolesData();
  }, [currentPage, pageSize]);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isCRoleModalOpen, setIsCRoleModalOpen] = useState(false);

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };
  const closeCRoleModal = () => {
    setIsCRoleModalOpen(false);
  };
  const [isUpdated, setIsUpdated] = useState(false);
  const [title, setTitle] = useState("");
  const [error, setError] = useState("");

  const editModuleupdate = () => {
    setIsUpdated(true);
    message.success("Role updated successfully!");
  };
  const handleTitleChange = (e) => {
    const { value } = e.target;
    if (/[^a-zA-Z\s]/.test(value)) {
      setError("Only alphabets are allowed. No numbers or special characters.");
    } else {
      setError("");
    }
    if (value.length <= 30) {
      setTitle(value);
    }
  };

  return (
    <>
      <WrapperBox>
        <div>
          {isUsersView && !isRoleFormView ? (
            <Card>
              <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center w-100">
                    <ButtonOutlined
                      onClick={() => {
                        setSelectedRole(null);
                        setFilterUser(null);
                        setRoleUserList([]);
                        fetchAllUserRolesList(null);
                        handleBackToRoles();
                      }}
                      className="Create_btn"
                    >
                      <LeftOutlined className="left_outlined_icon" />
                    </ButtonOutlined>
                    <label
                      style={{
                        marginBottom: 0,
                        marginLeft: 10,
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      {selectedRole?.ROLENAME || ""}
                    </label>

                    <div className="consingment_container_two">
                      <Select
                        value={filterUser}
                        style={{ width: "193px", marginTop: "10px" }}
                        onChange={(value) => {
                          setFilterUser(value);
                          fetchAllUserRoles(selectedRole?.ROLEID, value);
                        }}
                        allowClear={true}
                        showSearch={true}
                        disabled={filterUser}
                        placeholder="Users"
                        optionLabelProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {Array.isArray(roleUserList) &&
                          roleUserList.map((item) => (
                            <Select.Option
                              key={item.UID}
                              value={item.UID}
                              label={item.FULLNM}
                            >
                              {item.FULLNM}
                            </Select.Option>
                          ))}
                      </Select>
                      <Tooltip title={!updateAllowed ? "No permission" : ""}>
                        <ButtonOutlined className="Create_btn_edit">
                          <EditIcon1
                            disabled={!updateAllowed}
                            onClick={(e) => {
                              // if (!updateAllowed) return;
                              e.stopPropagation();
                              openEditRoleForm(selectedRole);
                            }}
                            style={{
                              cursor: updateAllowed ? "pointer" : "not-allowed",
                            }}
                          />
                        </ButtonOutlined>
                      </Tooltip>
                      <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                        <ButtonOutlined className="Create_btn_edit">
                          <DeleteIcon1
                            disabled={!deleteAllowed}
                            onClick={(e) => {
                              if (!deleteAllowed) return;
                              e.stopPropagation();
                              if (selectedRole?.UserCount > 0) {
                                openDeleteModal1(); // Show "cannot delete" modal
                              } else {
                                openDeleteModal(selectedRole); // Show normal delete modal
                              }
                            }}
                            style={{
                              cursor: deleteAllowed ? "pointer" : "not-allowed",
                            }}
                          />
                        </ButtonOutlined>
                      </Tooltip>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                  {/* Left side */}
                  <label style={{ fontSize: "16px" }}>
                    {selectedRole?.UserCount || ""} Users
                  </label>
                  <Tooltip title={!createAllowed ? "No permission" : ""}>
                    <ChangeRole
                      disabled={!selectedRows.length || !assignRoleAllowed}
                      onClick={(e) => {
                        if (!assignRoleAllowed) return;

                        if (!selectedRows.length) {
                          message.warning("Please select at least one user");
                          return;
                        }

                        e.stopPropagation();

                        setSelectedRole(null);
                        form.resetFields();
                        setIsCRoleModalOpen(true);
                      }}
                      style={{
                        cursor: assignRoleAllowed ? "pointer" : "not-allowed",
                      }}
                    />
                  </Tooltip>
                </div>
                <br />

                <Spin spinning={loading}>
                  <StyledTable
                    dataSource={
                      Array.isArray(userRolesData) ? userRolesData : []
                    }
                    columns={UserRolesColumn}
                    pagination={false}
                  />
                  <ReusablePagination
                    pageSize={roleAssignedPageSize}
                    handlePageSizeChange={handlePageSizeChange1}
                    currentPage={currentAssignedPage}
                    total={userRolesTotal}
                    handlePageChange={handlePageChange1}
                  />
                </Spin>
              </div>
              <UIModal
                open={isDeleteModalOpen}
                onClose={closeDeleteModal}
                size="600px"
                closeButton={false}
              >
                <center>
                  <RedDelete />
                </center>
                <center
                  style={{
                    fontSize: "20px",
                    fontWeight: 500,
                    color: "black",
                    marginTop: "10px",
                  }}
                >
                  Delete Role?
                </center>

                <center
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#5F6D8C",
                    marginTop: "10px",
                  }}
                >
                  This action will permanently delete the selected roles.
                </center>
                <center
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#5F6D8C",
                  }}
                >
                  Do you want to proceed?
                </center>
                <br />
                <div className="mt-2 w-100 d-flex justify-content-center">
                  <Buttontransparent onClick={closeDeleteModal}>
                    Cancel
                  </Buttontransparent>

                  <ButtonFilled
                    loading={loading}
                    onClick={handleDeleteRole}
                    disabled={loading}
                    // style={{ position: "relative" }}
                  >
                    {loading ? <span>Confirm</span> : "Confirm"}
                  </ButtonFilled>
                </div>
              </UIModal>
              <UIModal
                open={isDeleteModalOpen1}
                onClose={closeDeleteModal}
                size="600px"
                closeButton={false}
              >
                <center>
                  <RedDelete />
                </center>
                <center
                  style={{
                    fontSize: "20px",
                    fontWeight: 500,
                    color: "black",
                    marginTop: "10px",
                  }}
                >
                  Unable to Delete Role!
                </center>

                <center
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#5F6D8C",
                    marginTop: "10px",
                  }}
                >
                  This role cannot be deleted while it is assigned to
                  users.{" "}
                </center>
                <center
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#5F6D8C",
                  }}
                >
                  Reassign the users to another role to proceed.
                </center>
                <br />
                <div className="mt-2 w-100 d-flex justify-content-center">
                  <ButtonFilled onClick={closeDeleteModal1}>Okay</ButtonFilled>
                </div>
              </UIModal>
              <UIModal
                header="Change Role"
                open={isCRoleModalOpen}
                onClose={closeCRoleModal}
                footer={[
                  <div
                    key="footer"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      gap: "15px",
                    }}
                  >
                    <Buttontransparent onClick={closeCRoleModal}>
                      Cancel
                    </Buttontransparent>
                    <ButtonFilled onClick={changeRole}>Update</ButtonFilled>
                  </div>,
                ]}
                size="550px"
                closeButton={false}
              >
                <div className="p-3">
                  <Form
                    form={form}
                    labelCol={{ span: 12 }} // Label width (6 out of 24)
                    wrapperCol={{ span: 24 }} // Input width (18 out of 24)
                    layout="vertical" // Horizontal layout
                    style={{ paddingBottom: "150px" }}
                  >
                    <Form.Item name="rolename" label="Select Role">
                      <Select
                        value={selectedUserRole}
                        onChange={handleChange}
                        placeholder="Select"
                        style={{ width: "100%" }}
                        allowClear={true}
                        showSearch={false} // since you're using custom search
                        dropdownRender={(menu) => (
                          <>
                            <div style={{ padding: "5px" }}>
                              <Input
                                placeholder="Search"
                                onChange={(e) => setSearchText(e.target.value)}
                              />
                            </div>
                            {menu}
                          </>
                        )}
                      >
                        {filteredRoles.map((role) => (
                          <Option key={role?.ROLEID} value={role?.ROLEID}>
                            {role?.ROLENAME}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Form>
                </div>
              </UIModal>
            </Card>
          ) : isRoleFormView ? (
            <Card>
              <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center w-100">
                    <ButtonOutlined
                      onClick={handleCancel}
                      className="Create_btn"
                    >
                      <LeftOutlined className="left_outlined_icon" />
                    </ButtonOutlined>
                    <label
                      style={{
                        marginBottom: 0,
                        marginLeft: 10,
                        fontSize: "18px",
                        fontWeight: 600,
                      }}
                    >
                      {isEditRole ? "Updating Role" : "Create New Role"}
                    </label>
                  </div>
                </div>
                <Spin spinning={loading}>
                  <Form
                    form={form}
                    layout="vertical"
                    onFinish={(vals) =>
                      handleCreateRole({ ...vals, permissions: permissionMap })
                    }
                  >
                    <Form.Item
                      label={<span>Role Name</span>}
                      name="rolename"
                      rules={[
                        {
                          required: true,
                          message: "Role name is required",
                        },
                        {
                          pattern: /^[a-zA-Z\s]+$/,
                          message:
                            "Only alphabetic characters and spaces are allowed",
                        },
                      ]}
                    >
                      <Input
                        placeholder="e.g. Sales"
                        className="rounded-pill"
                        maxLength={30}
                        onChange={handleTitleChange}
                      />
                    </Form.Item>
                    {error ? (
                      <div style={{ color: "#ff4d4f", marginTop: -12 }}>
                        {error}
                      </div>
                    ) : null}
                    <div
                      style={{
                        fontWeight: 500,
                        marginBottom: 12,
                        marginTop: 8,
                      }}
                    >
                      Select Permissions
                    </div>
                    <StyledTable
                      dataSource={permissionTableData}
                      columns={permissionColumns}
                      pagination={false}
                      rowKey="key"
                      scroll={{ x: true }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        gap: "15px",
                        marginTop: 24,
                      }}
                    >
                      <Buttontransparent onClick={handleCancel}>
                        Cancel
                      </Buttontransparent>
                      <ButtonFilled
                        loading={loading}
                        onClick={() => form.submit()}
                      >
                        {isEditRole ? "Update" : "Create"}
                      </ButtonFilled>
                    </div>
                  </Form>
                </Spin>
              </div>
            </Card>
          ) : (
            <Card>
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <label style={{ fontSize: "16px" }}>{total} Roles</label>
                  {/* Right side (Select + Icon together) */}
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "10px" }}
                  >
                    <Select
                      value={filterUser}
                      style={{ width: "193px" }}
                      onChange={(value) => {
                        setFilterUser(value);
                        setIsUsersView(true);

                        const selectedUser = Array.isArray(roleUserList)
                          ? roleUserList.find((u) => u?.UID === value)
                          : null;

                        const roleId =
                          selectedUser?.ROLEID ??
                          filterRole ??
                          selectedRole?.ROLEID;
                        if (!roleId) return;
                        const matchedRole =
                          Array.isArray(roleList) && roleList.length
                            ? roleList.find(
                                (r) => String(r?.ROLEID) === String(roleId),
                              ) || null
                            : null;
                        // Fallback: build enough role info from the selected user record
                        setSelectedRole(
                          matchedRole || {
                            ROLEID: roleId,
                            ROLENAME: selectedUser?.ROLENAME || "",
                          },
                        );
                        fetchAllUserRoles(roleId, value);
                      }}
                      allowClear
                      showSearch
                      placeholder="Users"
                      optionLabelProp="children"
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {roleUserList?.map((item) => (
                        <Select.Option
                          key={`${item.UID}-${item.ROLEID}`}
                          value={item.UID}
                          label={`${item.ROLENAME} - ${item.FULLNM}`}
                        >
                          {item.FULLNM} - <strong>{item.ROLENAME}</strong>
                        </Select.Option>
                      ))}
                    </Select>
                    <Select
                      value={filterRole}
                      style={{
                        width: "193px",
                      }}
                      onChange={(value) => {
                        setFilterRole(value); // update selected value
                        const matchedRole = Array.isArray(roleList)
                          ? roleList.find((item) => item?.ROLEID === value) ||
                            null
                          : null;
                        setSelectedRole(matchedRole);
                        fetchAllUserRolesList(value || null);
                        fetchRolesData(value);
                      }}
                      allowClear={true}
                      showSearch={true}
                      placeholder="Role"
                      optionLabelProp="children"
                      filterOption={(input, option) =>
                        option?.children
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      <>
                        {roleList.map((item) => (
                          <Select.Option
                            key={item.ROLEID}
                            value={item.ROLEID}
                            label={item.ROLENAME}
                          >
                            {item.ROLENAME}
                          </Select.Option>
                        ))}
                      </>
                    </Select>
                    <Tooltip title={!createAllowed ? "No permission" : ""}>
                      <ButtonFilled
                        disabled={!createAllowed}
                        onClick={openCreateRoleForm}
                        style={{
                          cursor: createAllowed ? "cursor" : "not-allowed",
                        }}
                      >
                        {" "}
                        + Create
                      </ButtonFilled>
                    </Tooltip>
                  </div>
                </div>
                <div>
                  <Spin spinning={loading}>
                    <StyledTable
                      dataSource={Array.isArray(rolesData) ? rolesData : []}
                      columns={RolesColumn}
                      pagination={false}
                      onRow={(record) => ({
                        onClick: () => handleRoleRowClick(record),
                        style: { cursor: "pointer" },
                      })}
                    />
                    <ReusablePagination
                      pageSize={pageSize}
                      handlePageSizeChange={handlePageSizeChange}
                      currentPage={currentPage}
                      total={total}
                      handlePageChange={handlePageChange}
                    />
                  </Spin>
                </div>

                <UIModal
                  header="Modifying Role"
                  open={isEditModalOpen}
                  onClose={closeEditModal}
                  footer={[
                    <div
                      key="footer"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        gap: "15px",
                      }}
                    >
                      <Buttontransparent onClick={closeEditModal}>
                        Cancel
                      </Buttontransparent>
                      <ButtonFilled onClick={editModuleupdate}>
                        Update
                      </ButtonFilled>
                    </div>,
                  ]}
                  size="550px"
                  closeButton={false}
                >
                  <div className="p-3">
                    <Form
                      form={form}
                      labelCol={{ span: 12 }} // Label width (6 out of 24)
                      wrapperCol={{ span: 24 }} // Input width (18 out of 24)
                      layout="vertical" // Horizontal layout
                      style={{ paddingBottom: "150px" }}
                    >
                      <Form.Item name="rolename" label="Title of the Role">
                        <Input placeholder="Admin" className="rounded-pill" />
                      </Form.Item>
                    </Form>
                  </div>
                </UIModal>

                <UIModal
                  open={isDeleteModalOpen}
                  onClose={closeDeleteModal}
                  size="600px"
                  closeButton={false}
                >
                  <center>
                    <RedDelete />
                  </center>
                  <center
                    style={{
                      fontSize: "20px",
                      fontWeight: 500,
                      color: "black",
                      marginTop: "10px",
                    }}
                  >
                    Delete Role?
                  </center>

                  <center
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#5F6D8C",
                      marginTop: "10px",
                    }}
                  >
                    This action will permanently delete the selected roles.
                  </center>
                  <center
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#5F6D8C",
                    }}
                  >
                    Do you want to proceed?
                  </center>
                  <br />
                  <div className="mt-2 w-100 d-flex justify-content-center">
                    <Buttontransparent onClick={closeDeleteModal}>
                      Cancel
                    </Buttontransparent>

                    <ButtonFilled
                      loading={loading}
                      onClick={handleDeleteRole}
                      disabled={loading}
                      // style={{ position: "relative" }}
                    >
                      {loading ? <span>Confirm</span> : "Confirm"}
                    </ButtonFilled>
                  </div>
                </UIModal>
                <UIModal
                  open={isDeleteModalOpen1}
                  onClose={closeDeleteModal}
                  size="600px"
                  closeButton={false}
                >
                  <center>
                    <RedDelete />
                  </center>
                  <center
                    style={{
                      fontSize: "20px",
                      fontWeight: 500,
                      color: "black",
                      marginTop: "10px",
                    }}
                  >
                    Unable to Delete Role!
                  </center>

                  <center
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#5F6D8C",
                      marginTop: "10px",
                    }}
                  >
                    This role cannot be deleted while it is assigned to
                    users.{" "}
                  </center>
                  <center
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#5F6D8C",
                    }}
                  >
                    Reassign the users to another role to proceed.
                  </center>
                  <br />
                  <div className="mt-2 w-100 d-flex justify-content-center">
                    <ButtonFilled onClick={closeDeleteModal1}>
                      Okay
                    </ButtonFilled>
                  </div>
                </UIModal>
              </div>
            </Card>
          )}
        </div>
      </WrapperBox>
    </>
  );
};

export default Role;
